<template>
	<div class="user-machine-group">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			title="Label group list"
			:visible.sync="dialogUserMachineGroup"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				height="450"
				:data="userMachineList"
				style="width: 100%">
				<el-table-column
					prop="equipmentNo"
					:show-overflow-tooltip="true"
					:label="$t('cUserMachineGroup.equipmentNo')"></el-table-column>
				<el-table-column
					prop="equipmentName"
					:show-overflow-tooltip="true"
					:label="$t('cUserMachineGroup.name')"></el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.close") }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "UserMachineGroup",
	props: {
		userEquipmentLabelTeamId: String,
		dialogUserMachineGroup: Boolean,
	},
	data() {
		return {
			userMachineList: [],
		};
	},
	methods: {
		closeDialog() {
			this.cancel();
		},
		openDialog() {
			this.loading = true;
			this.$api
				.request(
					this.$url.UserMachine.listUserMachineSelect,
					this.$method.get,
					{ labelTeamId: this.userEquipmentLabelTeamId }
				)
				.then(res => {
					if (res.code === 0) {
						this.userMachineList = res.data.records;
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		cancel() {
			this.$emit("cancelUserMachineGroup", false);
		},
	},
};
</script>

<style scoped></style>
